import { GGOBaseComponent } from '@galigeo-store/ui-lib';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { publish } from 'pubsub-js';
import { PUBSUB_TOPICS } from '../../../state/pubsub';

@customElement('panel-item')
export class ItemComponent extends GGOBaseComponent {
  @property({ type: Boolean }) panelOpen = false; // Determines if the panel is open
  @property({ type: Object }) element: any = {}; // Item data (optional)
  @property({ type: String }) active: boolean = false;
  @property({ type: Boolean, reflect: true }) delayedOpen = false; // Determines if the profile is open
  @property({ type: Boolean }) isSelected = false; // Determines if the item is selected

  plusButtonVisible: boolean = false;

  static get styles() {
    return [
      css`
        :host {
          display: block;
          padding: 4px;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        .item {
          display: flex;
          align-items: center;
          border-radius: 6px;
          color: #fff;
          border: solid 1px transparent;
          font-weight: 500;
          -webkit-transition: all ease 0.3s;
          -moz-transition: all ease 0.3s;
          transition: all ease 0.3s;
          text-decoration: none;
        }
        .icon {
          width: 20px;
          height: 20px;
          padding: 14px;
          flex-shrink: 0;
          fill: #fff;
        }
        .label {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-left: 8px;
        }
        .label.hidden {
          display: none;
        }
        .item:hover {
          border: solid 1px #fff;
        }
        .item.active {
          box-shadow: inset 300px 0 0 0 #ffffff;
          color: #1b96ff;
          transition: background-color 0.2s all-ease;
        }
        .item.active svg {
          fill: #1b96ff;
        }
        .hidden {
          display: none;
        }
        .add-icon {
          width: 16px;
          height: 16px;
          padding: 7px;
          flex-shrink: 0;
          display: block;
        }
        .add-container {
          margin-left: auto;
          margin-right: 1rem;
          border-radius: 4px;
          border: solid 1px #e5e5e5;
          padding: 0.5rem;
        }
      `,
    ];
  }

  hoverHandler(type: string) {
    if (type === 'over') {
      //this.plusButtonVisible = true;
      this.active = true;
    }
    if (type === 'out') {
      //this.plusButtonVisible = false;
      this.active = false;
    }
    this.requestUpdate();
  }

  render() {
    // The plus button is visible if the item has a type and at least one map,
    // or if it has no type and more than one map
    this.plusButtonVisible = this.element.type && this.element.maps?.length > 0;

    let link = '';

    if (this.element.type) {
      link = `#${this.element.type}`;
    } else if (this.element.maps?.length === 1 && !this.active && !this.isSelected) {
      link = `#${this.element.maps[0].categoryId}?viewerId=${this.element.maps[0].id}`;
    }
    const htmlelement = html`
      <a
        href=${link !== '' ? link : nothing}
        ?disabled="${link === ''}"
        class="item ${this.active || this.isSelected ? 'active' : ''}"
        @click="${(e: Event) =>
          publish(PUBSUB_TOPICS.MENU_CLICKED, {
            element: this.element,
            event: e,
          })}"
        @mouseover="${() => this.hoverHandler('over')}"
        @mouseout="${() => this.hoverHandler('out')}"
      >
        ${this.element.icon
          ? html`<svg
              class="icon"
              xmlns="http://www.w3.org/2000/svg"
              alt="icon"
              preserveAspectRatio="xMidYMid meet"
            >
              <use href="${this.element.icon}" />
            </svg>`
          : ''}
        <span class="label ${this.panelOpen ? '' : 'hidden'}"
          >${this.element.label}</span
        >
        <div
          class="add-container ${this.panelOpen && this.isSelected
            ? ''
            : 'hidden'}"
          @click="${(e: Event) => {
            e.stopPropagation();
            e.preventDefault();
            publish(PUBSUB_TOPICS.PLUS_BTN_CLICKED, { clickedElement: this.element});
          }}"
        >
          <ggo-button variant="neutral" icon="collection_alt"></ggo-button>
        </div>
      </a>
    `;
    return htmlelement;
  }
}
